import {JetView} from "webix-jet"; // Importing JetView from webix-jet framework
import {devConfig, countries, providersCasino, subprovidersCasino, gamesCasino, profile} from "config/config"; // Importing configuration constants

/**
 * Class representing the FilterPartnersProductsView.
 * @extends JetView
 */
export default class FilterPartnersProductsView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService("locale")._; // Localization service
        const screen = this.app.config.size; // Screen size configuration
        const id_partner = this.getParam("partner", true); // Get partner ID from parameters

        // Left section configuration
        const left = {
            margin: 5,
            minWidth: 100,
            rows: [{
                margin: 15,
                css: "on-row",
                cols: [
                {
                    view: "combo", name: "ProviderId", // Combo box for selecting provider
                    localId: "provider:combo",
                    label: _("Proveedor"), labelPosition: "top",
                    placeholder: _("Click para seleccionar "),
                    options:{
                      body:{
                        dataFeed: function (text) { // Function to fetch provider data
                          var vthis = this;
                          if(text.length>2){ // Only fetch if input length is greater than 2
                            webix.ajax().headers({
                                "Content-type": "application/json"
                            }).post(devConfig.geturlApi() + "es/Select/ProvidersCasinoSelect", '{"Filter":"'+text+'"}', {
                                error: function (text, data, XmlHttpRequest) {
                                    webix.message("Error! "); // Error message on failure
                                },
                                success: function (text, data, XmlHttpRequest) {
                                    var resp = JSON.parse(text); // Parse response
                                    if (!resp.HasError) {
                                        vthis.parse(resp.Data); // Populate combo with data
                                    }
                                }
                            });
                          }
                        }
                      }
                    }
                },
                {
                    view: "combo", name: "SubProviderId", // Combo box for selecting sub-provider
                    localId: "subProvider:combo",
                    label: _("Sub Proveedor"), labelPosition: "top",
                    placeholder: _("Click para seleccionar "),
                    options:{
                      body:{
                        dataFeed: function (text) { // Function to fetch sub-provider data
                          var vthis = this;
                          if(text.length>2){ // Only fetch if input length is greater than 2
                            webix.ajax().headers({
                                "Content-type": "application/json"
                            }).post(devConfig.geturlApi() + "es/Select/SubProvidersCasinoSelect", '{"Filter":"'+text+'"}', {
                                error: function (text, data, XmlHttpRequest) {
                                    webix.message("Error! "); // Error message on failure
                                },
                                success: function (text, data, XmlHttpRequest) {
                                    var resp = JSON.parse(text); // Parse response
                                    if (!resp.HasError) {
                                        vthis.parse(resp.Data); // Populate combo with data
                                    }
                                }
                            });
                          }
                        }
                      }
                    }
                }
                ]
            }, {
                margin: 15,
                css: "on-row",
                cols: [
                {
                    view: "text", name: "Name", // Text input for name
                    label:  _("Nombre"), labelPosition: "top",
                    placeholder: _("Nombre"),
                    invalidMessage: _("Id is required") // Validation message
                },
                {
                    view: "richselect", name: "PartnerReference", // Rich select for partner reference
                    label: _("Partner Referencia"), labelPosition: "top",
                    placeholder: _("Click para seleccionar "),
                    options: profile.Partners // Options from profile
                }]},{
                margin: 15,
                css: "on-row",
                cols: [
                {
                            view: "richselect", name: "CountrySelect", id:"CountrySelect", minWidth:200, // Rich select for country selection
                            localId: "regions:combo",
                            label: "<span class='icon-language'></span>" + _("País"), labelPosition: "top",
                            placeholder: _("Click para seleccionar "),
                            on: {
                                onChange:function(data, obj){ // Event handler for change
                                    var currentValue = this.getValue();
                                    if (currentValue.length > 0) {
                                        $$('button').enable(); // Enable button if value is selected
                                        $$('button2').enable();
                                    } else {
                                        $$('button').disable(); // Disable button if no value
                                        $$('button2').disable();
                                    }
                                }
                            },
                            options:{
                                body:{
                                    template:function(obj){ // Template for displaying country options
                                        return  "<i class='flags "+ obj.icon +"'></i>" +obj.value;
                                    },
                                    data:countries // Country data
                                }
                            }, hidden:!devConfig.getPermAction("filterByCountry", "Add"), css:"prm-filterByCountry" // Conditional visibility
                        },{}
                        ]}
                ]
            };

            // Second left section configuration
            const left2 = {
                margin: 5,
                minWidth: 100,
                rows: [{
                    margin: 15,
                    css: "on-row",
                    cols: [
                    {
                            view: "richselect", name: "IsVerified", // Rich select for verification status
                            label: "<span class='icon-verified_user'></span>"+ _("Verificado"), labelPosition: "top",
                            placeholder: _("Click para seleccionar "),
                            options: [
                            {"id": "null", "value": _("Todos")},
                            {"id": "A", "value": _("Activado")},
                            {"id": "I", "value": _("Inactivado")}
                            ]
                        },
                        {
                            view: "richselect", name: "FilterCountry", // Rich select for country filter
                            label: "<span class='icon-language'></span>" + _("Filtro País"), labelPosition: "top",
                            placeholder: _("Click para seleccionar "),
                            options: [
                            {"id": "", "value": _("Todos")},
                            {"id": "A", "value": _("Activado")},
                            {"id": "I", "value": _("Inactivado")}
                            ]
                        },
                        {
                            view: "text", name: "FeaturedOrder", type: "number", // Text input for featured order
                            label: "<span class='icon-reorder'></span>"+ _("Orden Destacado"), labelPosition: "top",
                            placeholder: _("Orden Destacado"),
                            invalidMessage: _("Máximo is required") // Validation message
                        }]}, {
                        margin: 15,
                        css: "on-row",
                        cols: [
                        {
                            view: "text", name: "Maximum", type: "number", // Text input for maximum value
                            label: _("Máximo"), labelPosition: "top",
                            placeholder: _("Máximo"),
                            invalidMessage: _("Máximo is required") // Validation message
                        },
                        {
                            view: "text", name: "Minimum", type: "number", // Text input for minimum value
                            label: _("Mínimo"), labelPosition: "top",
                            placeholder: _("Mínimo"),
                            invalidMessage: _("Mínimo is required") // Validation message
                        },
                        {
                            view: "text", name: "ProcessingTime", type: "number", // Text input for processing time
                            label: "<span class='icon-history'></span>"+_("Tiempo Procesamiento"), labelPosition: "top",
                            placeholder: _("Tiempo Procesamiento"),
                            invalidMessage: _("Tiempo Procesamiento is required") // Validation message
                        }]},{
                           margin: 15,
                           css: "on-row",
                           cols: [
                             {
                                 view:"radio", name:"TypeDevice",label: _("Dispositivo"), labelPosition: "top", // Radio buttons for device type
                                 value:3,  options:[
                                     {"id":1, value:"<span class='icon-phone'></span>"},
                                     {"id":2, value:"<span class='icon-display'></span>"},
                                     {"id":3, value:_('Ambos')}
                                 ]
                               },
                               {id: "grav2", gravity:1, } // Gravity for layout
                            ]
                     }]
                    };

            // Upper section configuration
            const upper_section = {
                css: "father-container", height: (document.body.offsetWidth < 500) ? 370 : 0, // Conditional height
                rows: [{
                    margin: 10,
                    cols: [
                    left, // Include left section
                    ]
                }]
            };

            // Second upper section configuration
            const upper_section2 = {
              css: "father-container", height: (document.body.offsetWidth < 500) ? 500 : 0, // Conditional height
              rows:[{
                margin: 10,
                cols: [
                left2 // Include second left section
                ]
            }]
        };

        // Accordion section configuration
        const accordion_section = {
           id: "b5",
           rows: [
           {
             multi: true,
             view: "accordion",
             css: "betShop",
             collapsed: true,
             paddingY: 10,
             type: "clean",
             rows: [
             {
               header: _("Filtros Avanzados"), body: {
                 padding:10,
                 rows: [upper_section2] // Include second upper section
             }
         }
         ]
     }
     ]
 };

        // Buttons configuration
        const buttons = {
            id: "b2",
            rows: [{
                margin: 10,
                responsive: "b2",
                cols: [
                {id: "grav", gravity: 4}, // Gravity for layout
                {
                    minWidth: 250,
                    view: "button", // Button for mass product addition
                    id: "button2",
                    disabled:true,
                    value: _("Productos Masivos"),
                    type: "form",
                    width: (screen == "small") ? 0 : 200, hidden:!devConfig.getPermAction("activeProductMassive", "Add"), css:"prm-productMassive",
                    click: () => {
                        function getBase64(file) { // Function to convert file to base64
                            return new Promise((resolve, reject) => {
                                const reader = new FileReader();
                                reader.readAsDataURL(file);
                                reader.onload = () => resolve(reader.result);
                                reader.onerror = error => reject(error);
                            });
                        }
                        var base64CSV2=""; // Variable to hold base64 CSV data
                        webix.ui({
                            view: "window", // Window for mass product addition
                            id: "ProductMassive",
                            fullscreen: (screen.width < 500) ? true : false,
                            head: {
                                view: "toolbar",
                                cols: [
                                    {view: "label", label: _("Agregar Productos Masivos")},
                                    {
                                        view: "icon", icon: "wxi-close", click: function () {
                                            this.getTopParentView().hide(); // Close window on icon click
                                        }
                                    }
                                ]
                            },
                            position: "center",
                            modal: true,
                            body: {
                                view: "form", id: "ProductMassiveForm", // Form for uploading CSV
                                elements: [
                                    {
                                        margin: 10,
                                        rows: [
                                            { view:"uploader",id:"uploader4", value:_("Cargar archivo CSV"), // Uploader for CSV file
                                                on:{
                                                    onBeforeFileAdd: function(upload){ // Event before file is added
                                                        if (upload.file.type !== "text/csv") {
                                                            webix.message({ type:"error", text: _("Solo se permiten archivos CSV") }); // Error message for invalid file type
                                                            return false;
                                                        }
                                                        getBase64(upload.file).then(
                                                            data => base64CSV2 = data // Convert file to base64
                                                        );
                                                        $$("uploader4").define("label", upload.name); // Update uploader label
                                                        $$("uploader4").refresh();
                                                    }
                                                }
                                            }
                                        ]
                                    },
                                    {
                                        cols: [
                                            {
                                                view: "button", value: _("Cancelar"), click: function () { // Cancel button
                                                    this.getTopParentView().hide(); // Close window
                                                    $$('ProductMassiveForm').setValues($$('ProductMassiveForm').getCleanValues()); // Reset form values
                                                    $$("uploader4").define("label", _("Cargar archivo CSV")); // Reset uploader label
                                                    $$("uploader4").refresh();
                                                    base64CSV2 = ""; // Clear base64 data
                                                }
                                            },
                                            {
                                                view: "button", type: "form", value: _("Guardar"), // Save button
                                                click: () => {
                                                    var values = $$("ProductMassiveForm").getValues(); // Get form values
                                                    const filterdata = this.getRoot().getValues(); // Get filter data
                                                    filterdata.Partner = id_partner; // Add partner ID to filter data
                                                    if($$("ProductMassiveForm").validate() && base64CSV2 != ""){ // Validate form and check base64 data
                                                        filterdata.CSV = base64CSV2; // Add base64 CSV to filter data
                                                        this.app.callEvent("partnerProducts:productMassive", [filterdata]); // Trigger event for mass product addition
                                                        $$('ProductMassiveForm').getTopParentView().close(); // Close window
                                                        $$('b1').collapse(); // Collapse filter section
                                                        $$('a5').scrollTo(100,0); // Scroll to position
                                                    }
                                                }
                                            }
                                        ]
                                    }
                                ], elementsConfig: {
                                    on: {
                                        onChange: function () {
                                            this.validate(); // Validate form on change
                                        }
                                    }
                                }
                            }
                        }).show() // Show the window
                    }
                },
                {
                    view: "button", value: _("Limpiar"), width: (screen == "small") ? 0 : 100, minWidth: 200, // Clear button
                    click: () => {
                        this.getRoot().clear(); // Clear form values
                    }
                },
                {
                    view: "button", // Consult button
                    id: "button",
                    disabled:true,
                    value: _("Consultar"),
                    type: "form",
                    width: (screen == "small") ? 0 : 100,
                    minWidth: 200,
                    click: () => {
                        const filterdata = this.getRoot().getValues(); // Get filter data
                        filterdata.Partner = id_partner; // Add partner ID to filter data
                        this.app.callEvent("partnerProducts:filter", [filterdata]); // Trigger filter event
    										$$("b1").collapse(); // Collapse filter section
    										$$('a5').scrollTo(100,0); // Scroll to position
                    }
                }
                ]
            }]
        };

        // Accordion section for filters
        const accordion_section1 = {
            type: "wide",
            rows: [
                {
                    multi: true,
                    view: "accordion",
                    css: "betShop",
                    collapsed: true,
                    type: "clean",
                    rows: [
                        {
                            header: _("Filtros"), id: "b1", body: {
                                padding: 10,
                                rows: [upper_section,buttons] // Include upper section and buttons
                            }
                        }
                    ]
                }
            ]
        };

        // Return the main configuration object for the view
        return {
            view: "form",
            type: "clean",
            rows: [
            accordion_section1 // Include accordion section
            ],
            rules: {
                "fname": webix.rules.isNotEmpty // Validation rule for name field
            }
        };
    }

    /**
     * Initializes the view and sets up event listeners.
     * @param {Object} grid - The grid object.
     */
    init(grid) {
        webix.ready(function () {
            if (screen.width < 500) {
                $$("grav").hide(); // Hide element on small screens
            }
        });
    }
}

// FILE DOCUMENTED
